import { defineComponent as o, Types as i } from "bitecs";
const n = o({
  shape: i.ui8,
  sizeX: i.f32,
  sizeY: i.f32,
  sizeZ: i.f32,
  color: i.ui32,
  visible: i.ui8,
  unlit: i.ui8
}), t = o({
  clearColor: i.ui32,
  hasCanvas: i.ui8
}), r = o({
  projection: i.ui8,
  fov: i.f32,
  orthoSize: i.f32
}), s = o({
  skyColor: i.ui32,
  groundColor: i.ui32,
  intensity: i.f32
}), c = o({
  color: i.ui32,
  intensity: i.f32,
  castShadow: i.ui8,
  shadowMapSize: i.ui32,
  directionX: i.f32,
  directionY: i.f32,
  directionZ: i.f32,
  distance: i.f32
});
export {
  s as AmbientLight,
  c as DirectionalLight,
  r as MainCamera,
  t as RenderContext,
  n as Renderer
};
//# sourceMappingURL=components.js.map
